<template>
            
                <b-tabs fill class="payment-tabs">
                  <b-tab  title-link-class="p-2 font-weight-bold custom-tab" title="Digital Displays" >
                      <section class="position-relative overflow-hidden">
                        <div class="position-sticky" style="top: 10px; right: inherit;">
                          <div class="h4 font-weight-bold mb-3">Tutorial List</div>
                          <div>
                            - Change WiFi Connection
                          </div>
                          
                          
                          <hr/>
                        </div>


                        <b-container fluid class="px-0">

                          <b-row class="align-items-center">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;">
                                <iframe src="https://player.vimeo.com/video/1041887548?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Business Profile Page Update"></iframe>                              </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Change WiFi Connection
                              </span>
                            </b-col>
                          </b-row>

                        </b-container>
                      </section>
                    </b-tab>
                    <b-tab  title-link-class="p-2 font-weight-bold custom-tab" title="Business Profile & Menu Update" >
                      <section class="position-relative overflow-hidden">
                        <div class="position-sticky" style="top: 10px; right: inherit;">
                          <div class="h4 font-weight-bold mb-3">Tutorial List</div>
                          <div>
                            - Updating Menu with Menu Editor
                          </div>
                          <div>
                            - Business Profile Page Update
                          </div>
                          
                          <hr/>
                        </div>


                        <b-container fluid class="px-0">

                         

                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                                <div style="padding:56.25% 0 0 0;position:relative;">
                                  <iframe src="https://player.vimeo.com/video/1033719813?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Updating Menu with Menu Editor"></iframe>                               </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Updating Menu with Menu Editor
                              </span>
                            </b-col>
                          </b-row>

                          <b-row class="align-items-center">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;">
                                <iframe src="https://player.vimeo.com/video/1033718162?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Business Profile Page Update"></iframe>                              </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Business Profile Page Update
                              </span>
                            </b-col>
                          </b-row>

                        </b-container>
                      </section>
                    </b-tab>
                    <b-tab  title-link-class="p-2 font-weight-bold custom-tab" title="Digital Ordering" class="position-relative">
                      <section class="position-relative overflow-hidden">
                        <div class="position-sticky" style="top: 10px; right: inherit;">
                          <div class="h4 font-weight-bold mb-3">Tutorial List</div>
                          <div>
                            - Allow MENUPOLY notifications in Chrome
                          </div>
                          <div>
                            - Receiving and processing Today Orders
                          </div>
                          <div>
                            - Create a pickup/takeout tab in dashboard
                          </div>
                          <div class="mb-4">
                            - Create a dine in tab in dashboard
                          </div>
                          <hr/>
                        </div>


                        <b-container fluid class="px-0">

                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/729228383?h=4752504086&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Allow MENUPOLY Notifications in Chrome"></iframe></div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Allow MENUPOLY notifications in Chrome
                              </span>
                            </b-col>
                          </b-row>

                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                              <div style="padding:56.12% 0 0 0;position:relative;">
                                <iframe src="https://player.vimeo.com/video/724364187?h=9216459b05&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Receiving and processing Today Orders"></iframe>
                              </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Receiving and processing Today Orders
                              </span>
                            </b-col>
                          </b-row>

                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                                <div style="padding:56.25% 0 0 0;position:relative;">
                                  <iframe src="https://player.vimeo.com/video/722191336?h=130bb1048e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Create Pickup_Takeout Tabs.mp4"></iframe>
                                </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Create a pickup/takeout tab in dashboard
                              </span>
                            </b-col>
                          </b-row>

                          <b-row class="align-items-center">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;">
                                <iframe src="https://player.vimeo.com/video/723083583?h=8a608ed495&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Create a Dine-in Tab in dashboard"></iframe>
                              </div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                Create a dine in tab in dashboard
                              </span>
                            </b-col>
                          </b-row>

                        </b-container>
                      </section>
                    </b-tab>
                    
                    
                    <b-tab  title-link-class="p-2 font-weight-bold custom-tab" title="Hardware Installs" class="position-relative">
                      <section class="position-relative overflow-hidden">
                        <div class="position-sticky" style="top: 10px; right: inherit;">
                          <div class="h4 font-weight-bold mb-3">Tutorial List</div>
                          <div>
                            - Movable Wall-Mount: Card reader attachment
                          </div>
                          <div>
                            - Movable Wall-Mount : Wall Extension Assembly
                          </div>
                          
                          <div class="mb-4">
                            - POS Terminal : Base Assembly
                          </div>
                          <hr/>
                        </div>


                        <b-container fluid class="px-0">

                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1186826801?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Card Reader Attachment Display Assembly"></iframe></div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                - Movable Wall-Mount: Card reader attachment
                              </span>
                            </b-col>
                          </b-row>
                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1186826986?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="WallMount Install -  Extension Assembly"></iframe></div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                - Movable Wall-Mount : Wall Extension Assembly
                              </span>
                            </b-col>
                          </b-row>
                          <b-row class="align-items-center mb-4">
                            <b-col cols="12" md="4">
                              <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1186826555?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="POS Terminal Base Assembly"></iframe></div>
                            </b-col>
                            <b-col cols="12" md="4">
                              <span>
                                - POS Terminal : Base Assembly                              
                              </span>
                            </b-col>
                          </b-row>

                         

                        </b-container>
                      </section>
                    </b-tab>
                    
                </b-tabs>
            
       
  
  
  
  
  
  
  
  
</template>

<script>
  export default {
    name: "tutorial",
    metaInfo () {
      return {
        title: 'Tutorial Videos'
      }
    },
    data() {
      return {
        tutorialModal: true
      }
    }
  }
</script>

<style scoped>

</style>
